"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime"); // Libs Alert


var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

require("./styles.css");

var Alert = function (_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'info' : _b,
      _c = _a.isDismissible,
      isDismissible = _c === void 0 ? true : _c,
      _d = _a.onClose,
      onClose = _d === void 0 ? function () {
    return null;
  } : _d,
      children = _a.children,
      className = _a.className,
      rest = __rest(_a, ["variant", "isDismissible", "onClose", "children", "className"]);

  var bem = (0, hook_use_bem_classes_1.default)('rwc-alert');
  var classes = (0, classnames_1.default)(className, bem(), bem('', variant));

  var hideElement = function (el) {
    var _a, _b;

    onClose(el);
    (_b = (_a = el.target) === null || _a === void 0 ? void 0 : _a.closest(".".concat(bem()))) === null || _b === void 0 ? void 0 : _b.remove();
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: classes,
    role: "alert"
  }, rest, {
    children: [(0, jsx_runtime_1.jsxs)("p", {
      children: [variant === 'success' ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-check",
        size: "20"
      }) : null, variant === 'critical' ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-triangle-exclamation",
        size: "20"
      }) : null, variant === 'warning' ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-circle-exclamation",
        size: "20"
      }) : null, variant === 'info' ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-info-circle",
        size: "20"
      }) : null, (0, jsx_runtime_1.jsx)("span", {
        children: children
      })]
    }), isDismissible && (0, jsx_runtime_1.jsx)("button", __assign({
      type: "button",
      "aria-label": "close",
      className: "alert-dismiss",
      onClick: hideElement
    }, {
      children: (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
        type: "fas-xmark",
        size: "16"
      })
    }))]
  }));
};

exports.default = Alert;